module.exports = __webpack_public_path__ + "img/loginNew.147044e5.png";